



if(!customElements.get('article-toc')) {
  class ArticleTableOfContents extends HTMLElement {
    constructor() {
      super();
      this.tocContainer = this.querySelector('.toc-list');
      this.articleBody = document.querySelector('.article .body');
      this.headings = [];
      this.init();
    }

    init() {
      if (!this.tocContainer || !this.articleBody) return;
      this.findHeadings();
      this.generateTOC();
      this.addSmoothScrolling();
      this.addActiveStateTracking();
    }

    findHeadings() {
      // Find all h2 headings specifically within the article body
      const h2Elements = this.articleBody.querySelectorAll('h2');
      
      this.headings = Array.from(h2Elements)
        .filter(heading => !heading.closest('.article-featured-products'))
        .map((heading, index) => {
          // Generate an ID if one doesn't exist
          if (!heading.id) {
            heading.id = `article-heading-${index + 1}`;
          }
          
          return {
            element: heading,
            id: heading.id,
            text: heading.textContent.trim(),
            index: index + 1
          };
        });
    }

    generateTOC() {
      if (this.headings.length === 0) {
        this.tocContainer.innerHTML = '<li class="toc-empty">No headings found in this article</li>';
        return;
      }

      const maxItems = this.getMaxItems();
      const showNumbers = this.getShowNumbers();
      
      const tocHTML = this.headings
        .slice(0, maxItems)
        .map((heading, index) => {
          const number = showNumbers ? `${index + 1}. ` : '';
          return `
            <li class="toc-item">
              <a href="#${heading.id}" class="toc-link" data-heading-id="${heading.id}">
                ${number}${heading.text}
              </a>
            </li>
          `;
        })
        .join('');

      this.tocContainer.innerHTML = tocHTML;
    }

    getMaxItems() {
      const tocBlock = this;
      if (tocBlock) {
        const dataMaxItems = tocBlock.getAttribute('data-max-items');
        return dataMaxItems ? parseInt(dataMaxItems) : 10;
      }
      return 10;
    }

    getShowNumbers() {
      const tocBlock = this;
      if (tocBlock) {
        return tocBlock.hasAttribute('data-show-numbers');
      }
      return false;
    }

    addSmoothScrolling() {
      this.tocContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('toc-link')) {
          e.preventDefault();
          
          const targetId = e.target.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            // Smooth scroll to the heading
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            
            // Update URL without page jump
            history.pushState(null, null, `#${targetId}`);
          }
        }
      });
    }

    addActiveStateTracking() {
      const observerOptions = {
        root: null,
        rootMargin: '0% 0px -50% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const headingId = entry.target.id;
          const tocLink = this.querySelector(`.toc-link[href="#${headingId}"]`);
          
          if (tocLink) {
            if (entry.isIntersecting) {
              // Remove active class from all links
              this.querySelectorAll('.toc-link').forEach(link => {
                link.classList.remove('active');
              });
              
              // Add active class to current link
              tocLink.classList.add('active');
            }
          }
        });
      }, observerOptions);

      // Observe all headings
      this.headings.forEach(heading => {
        observer.observe(heading.element);
      });
    }
  }
  customElements.define('article-toc', ArticleTableOfContents);
}

